<template>
  <div>
    <FITFormCard>
      <b-row slot="header" align-v="center">
        <b-col cols="6">
          <h5><i class="fa fa-info-circle mr-2"></i>{{$t('osm.contents.giPolicy.generalInfo')}}</h5></b-col>
        <b-col cols="auto" class="ml-auto text-right">
          <b-row align-v="center">
            <b-col cols="auto" class="ml-auto">
              <div class="pb-2">
                <span v-if="workflowCurrentIndex > 5" class="bg-success text-white ml-auto p-2 rounded "><b>{{ $t('osm.contents.giPolicy.generalInformation.approveAgent') }} :{{approveAgentName}}</b></span>
              </div>
            </b-col>
            <b-col>
              <h4 v-if="showLockIcon && !isPolicyRejected && !isPolicyCompleted && permissionLevel < 3.5" @click="changeLockStatus" style="cursor:pointer">
                <i v-if="isLocked" class="fa fa-lock"></i>
                <i v-else class="fa fa-unlock "></i> 
              </h4>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div slot="formBody">
        <b-row class="mb-0 pb-0">
          <b-col cols="6">
            <FITAutoSearch field="productID" v-if="!fields.productName.hide" :label="$t('osm.contents.giPolicy.generalInformation.productName')" :width="8" v-model="selectedProduct" dest=option v-bind="productAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.productName.disabled"></FITAutoSearch>
            <FITTextInput field="policyNumber" v-if="!fields.policyNumber.hide" :label="$t('osm.contents.giPolicy.generalInformation.policyNumber')" :width="8" v-model="giGeneralInfo.policyNumber" :disabled="isAllFieldsDisabled &&  fields.policyNumber.disabled"></FITTextInput>
<!--             <FITTextInput field="policyReference" v-if="!fields.policyReference.hide" :label="$t('osm.contents.giPolicy.generalInformation.policyReference')" :width="8" v-model="giGeneralInfo.policyReference" :disabled="isAllFieldsDisabled &&  fields.policyReference.disabled"></FITTextInput> -->
            <FITDatePicker field="applicationDate" v-if="!fields.applicationDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.applicationDate')" :width="8" v-model="giGeneralInfo.applicationDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.applicationDate.disabled"></FITDatePicker>
            <FITSelect field="newBusinessOrRenewal" v-if="!fields.newBusinessOrRenewal.hide" :label="$t('osm.contents.giPolicy.generalInformation.newBusinessOrRenewal')" :width="8" v-model="giGeneralInfo.newBusinessOrRenewal" :options="getTranslatedOptions(`${$i18n.locale}`,newBusinessOrRenewalOptions)" :disabled="isAllFieldsDisabled && fields.newBusinessOrRenewal.disabled"></FITSelect>
          </b-col>
          <b-col cols="6">
            <FITSelect field="policyType" v-if="!fields.policyType.hide" :label="$t('osm.contents.giPolicy.generalInformation.policyType')" :width="8" v-model="giGeneralInfo.policyType" :disabled=" fields.policyType.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,policyTypeList)"></FITSelect>
            <!-- <FITAutoSearch v-if="!fields.originalAgent.hide" :label="$t('osm.contents.giPolicy.generalInformation.originalAgent')" :width="8" v-model="originalAgent" dest="option" v-bind="agentAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.originalAgent.disabled"></FITAutoSearch>
            <FITAutoSearch v-if="!fields.currentAgent.hide" :label="$t('osm.contents.giPolicy.generalInformation.currentAgent')" :width="8" v-model="currentAgent" dest="option" v-bind="agentAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.currentAgent.disabled"></FITAutoSearch> -->
            <FITAutoSearch field="ownerCustomer" v-if="!fields.ownerCustomer.hide" :label="$t('osm.contents.giPolicy.generalInformation.ownerCustomer')" :width="8" v-model="ownerCustomer" dest="option" v-bind="customerAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.ownerCustomer.disabled"></FITAutoSearch>
            <FITAutoSearch field="insuredCustomer" v-if="!fields.insuredCustomer.hide" :label="$t('osm.contents.giPolicy.generalInformation.insuredCustomer')" :width="8" v-model="insuredCustomer" dest="option" v-bind="customerAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.insuredCustomer.disabled"></FITAutoSearch>
            <FITDatePicker field="applicationReceiveDate" v-if="!fields.applicationReceiveDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.applicationReceiveDate')" :width="8" v-model="giGeneralInfo.applicationReceiveDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.applicationReceiveDate.disabled"></FITDatePicker>
          </b-col>
          <b-col>
            <FITTextarea field="remarks" :label="$t('osm.contents.giPolicy.generalInformation.remarks')" :rows="3" :width="10" v-model="giGeneralInfo.remarks" :disabled="isAllFieldsDisabled &&  fields.remarks.disabled"></FITTextarea>
            <!-- <b-row align-v="center"> -->
            <!-- <b-col  cols="2">{{$t('osm.contents.giPolicy.generalInformation.docs')}}</b-col> -->
            <!-- <b-col cols="10" > -->
            <FITWorkflowFileUpload ref="fitFileUpload" :disabled="isAllFieldsDisabled && fields.docs.disabled" :uploadedFiles="uploadedFiles"></FITWorkflowFileUpload>
          </b-col>
        </b-row>
        </b-row>
        <!-- Start of money sections -->
        <template v-if="!fields.policyCurrency.hide">
          <hr style="color:black; height:1px;" />
          <h3><b><i class="fa fa-credit-card mr-2"></i>{{$t('osm.contents.giPolicy.payment')}}</b></h3>
          <b-row>
            <b-col>
              <FITSelect field="policyCurrency" v-if="!fields.policyCurrency.hide" :label="$t('osm.contents.giPolicy.generalInformation.policyCurrency')" :width="8" v-model="giGeneralInfo.policyCurrency" :disabled="isAllFieldsDisabled &&  fields.policyCurrency.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,policyCurrency)"></FITSelect>
              <FITTextInput field="customerActuallyPaid" v-if="!fields.actuallyPaid.hide" :label="$t('osm.contents.giPolicy.generalInformation.actuallyPaid')" :width="8" :disabled="isAllFieldsDisabled &&  fields.actuallyPaid.disabled" v-model="actuallyPaid"></FITTextInput>
              <FITTextInput field="levyOrMib" v-if="!fields.levyOrMIB.hide" :label="$t('osm.contents.giPolicy.generalInformation.levyOrMIB')" :width="8" v-model="giGeneralInfo.levyOrMib" :disabled="isAllFieldsDisabled &&  fields.levyOrMIB.disabled"></FITTextInput>
              <FITTextInput field="policyFee" v-if="!fields.policyFee.hide" :label="$t('osm.contents.giPolicy.generalInformation.policyFee')" :width="8" v-model="giGeneralInfo.policyFee" :disabled="isAllFieldsDisabled &&  fields.policyFee.disabled"></FITTextInput>
            </b-col>
            <b-col>
              <FITTextInput field="modalPremium" v-if="!fields.modalPremium.hide" :label="$t('osm.contents.giPolicy.generalInformation.modalPremium')" :width="8" v-model="giGeneralInfo.modalPremium" :disabled="isAllFieldsDisabled &&  fields.modalPremium.disabled"></FITTextInput>
              <FITSelect field="premiumPaid" v-if="!fields.premiumPaid.hide" :label="$t('osm.contents.giPolicy.generalInformation.premiumPaid')" :width="8" :disabled="isAllFieldsDisabled &&  fields.premiumPaid.disabled" v-model="giGeneralInfo.premiumPaid" :options="trueFalseOptions"></FITSelect>
              <FITTextInput field="specialLevy" :rule="{decimal:true}" v-if="!fields.specialLevy.hide" :label="$t('osm.contents.giPolicy.generalInformation.specialLevy')" :width="8" v-model="giGeneralInfo.specialLevy" :disabled="isAllFieldsDisabled && fields.specialLevy.disabled"></FITTextInput>
              <FITTextInput field="insureRebate" v-if="!fields.insurerRebate.hide" :label="$t('osm.contents.giPolicy.generalInformation.insurerRebate')" :width="8" v-model="giGeneralInfo.insurerRebate" :disabled="isAllFieldsDisabled &&  fields.insurerRebate.disabled"></FITTextInput>
              <!--   <FITTextInput v-if="!fields.agentCommissionRate.hide" :label="$t('osm.contents.giPolicy.generalInformation.agentCommissionRate')" :width="8"  v-model="giGeneralInfo.agentCommissionRate" :disabled="isAllFieldsDisabled &&  fields.agentCommissionRate.disabled"></FITTextInput> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <!-- <FITSelect v-if="!fields.premiumType.hide" :label="$t('osm.contents.giPolicy.generalInformation.premiumType')" :width="8" :disabled="isAllFieldsDisabled &&  fields.premiumType.disabled" :options="premiumTypeOptions"></FITSelect> -->
              <FITSelect field="paymentMethod" v-if="!fields.paymentMethod.hide" :label="$t('osm.contents.giPolicy.generalInformation.paymentMethod')" :width="8" :disabled="isAllFieldsDisabled &&  fields.paymentMethod.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,paymentMethodList)" v-model="giPaymentMethod.paymentMethod"></FITSelect>
              <!--               <FITSelect field="companyBank" v-if="!fields.companyBank.hide" :label="$t('osm.contents.giPolicy.generalInformation.companyBank')" :width="8" :disabled="isAllFieldsDisabled &&  fields.companyBank.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,companyBankList)" v-model="giPaymentMethod.companyBank"></FITSelect> -->
              <!-- <FITTextInput v-if="!fields.paymentAmount.hide"  :label="$t('osm.contents.giPolicy.generalInformation.paymentAmount')" :width="8" :disabled="isAllFieldsDisabled &&  fields.paymentAmount.disabled" v-model="giPaymentMethod.paymentAmount"></FITTextInput> -->
            </b-col>
            <b-col cols="6">
              <FITDatePicker field="paymentDate" v-if="!fields.paymentDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.paymentDate')" :width="8" :disabled="isAllFieldsDisabled &&  fields.paymentDate.disabled" v-model="giPaymentMethod.paymentDate"></FITDatePicker>
              <FITTextInput field="paymentReference" v-if="!fields.paymentReference.hide" :label="$t('osm.contents.giPolicy.generalInformation.paymentReference')" :width="8" :disabled="isAllFieldsDisabled &&  fields.paymentReference.disabled" v-model="giPaymentMethod.paymentReference"></FITTextInput>
            </b-col>
          </b-row>
        </template>
        <PolicyAgent v-model="giGeneralInfo.policyAgent" :allDisabled="isAllFieldsDisabled && fields.policyAgent.disabled" translateKey="osm.contents.giPolicy.generalInformation.policyAgent" :haveAction="true">
          <div slot="afterSection">
            <FITTextarea :disabled="isAllFieldsDisabled && fields.policyAgent.disabled || permissionLevel > 3.5" :width="10" v-model="giGeneralInfo.policyAgentChangeReason" :label="$t('osm.contents.general.agentRemarks')"></FITTextarea>
          </div>
        </PolicyAgent>
 <!--        <template v-if="!fields.agentCommissionPaid.hide">
          <hr style="color:black; height:1px;" />
          <h3><b><i class="fa fa-users mr-2"></i>{{$t('osm.contents.giPolicy.commission')}}</b></h3>
          <b-row>
            <b-col cols="6">
              <FITSelect field="agentCommissionPaid" v-if="!fields.agentCommissionPaid.hide" :label="$t('osm.contents.giPolicy.generalInformation.agentCommissionPaid')" :width="8" v-model="giGeneralInfo.agentCommissionPaid" :disabled="isAllFieldsDisabled &&  fields.agentCommissionPaid.disabled" :options="trueFalseOptions"></FITSelect>
               <b-row class="mt-3">
                <b-col cols="4">Agent Net</b-col>
                <b-col cols="8"><b>{{agentNet}}</b></b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="4">Agent Commission</b-col>
                <b-col cols="8"><b>{{agentCommission}}</b></b-col>
              </b-row>
            </b-col>
            <b-col cols="6"></b-col>
          </b-row>
        </template> -->
        <template v-if="!fields.chequeToInsurer.hide">
          <hr style="color:black; height:1px;" />
          <h3><b><i class="fa fa-user-secret mr-2"></i>{{$t('osm.contents.giPolicy.internalUse')}}</b></h3>
          <b-row>
            <b-col cols="6">
              <FITTextInput field="chequeToInsurer" v-if="!fields.chequeToInsurer.hide" :label="$t('osm.contents.giPolicy.generalInformation.chequeToInsurer')" :width="8" v-model="giGeneralInfo.chequeToInsurer" :disabled="isAllFieldsDisabled &&  fields.chequeToInsurer.disabled"></FITTextInput>
              <FITDatePicker field="chequeIssueDate" v-if="!fields.chequeIssueDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.chequeIssueDate')" :width="8" v-model="giGeneralInfo.chequeIssueDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.chequeIssueDate.disabled"></FITDatePicker>
            </b-col>
            <b-col cols="6">
              <FITTextInput field="chequeToInsurerNumber" v-if="!fields.chequeToInsurerNumber.hide" :label="$t('osm.contents.giPolicy.generalInformation.chequeToInsurerNumber')" :width="8" v-model="giGeneralInfo.chequeToInsurerNumber" :disabled="isAllFieldsDisabled &&  fields.chequeToInsurerNumber.disabled"></FITTextInput>
            </b-col>
          </b-row>
        </template>
        <template v-if="!fields.sentOutMedium.hide">
          <b-row>
            <b-col cols="6">
              <FITSelect field="sentOutMedium" v-if="!fields.sentOutMedium.hide" :label="$t('osm.contents.giPolicy.generalInformation.sentOutMedium')" :width="8" v-model="giGeneralInfo.sentOutMedium" :options="getTranslatedOptions(`${$i18n.locale}`,sentOutMediumOptions)" :disabled="isAllFieldsDisabled &&  fields.sentOutMedium.disabled || permissionLevel>3.5"></FITSelect>
              <FITDatePicker field="sentOutDate" v-if="!fields.sentOutDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.sentOutDate')" :width="8" v-model="giGeneralInfo.sentOutDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.sentOutDate.disabled || permissionLevel>3.5"></FITDatePicker>
            </b-col>
            <b-col cols="6">
              <FITTextInput field="sentOutReference" v-if="!fields.sentOutReference.hide" :label="$t('osm.contents.giPolicy.generalInformation.sentOutReference')" v-model="giGeneralInfo.sentOutReference" :width="8"  :disabled="isAllFieldsDisabled &&  fields.sentOutReference.disabled || permissionLevel>3.5"></FITTextInput>
            </b-col>
          </b-row>
        </template>
        <template v-if="!fields.effectiveDate.hide">
          <b-row>
            <hr style="color:black; height:1px;" />
            <b-col cols="6">
              <FITDatePicker field="effectiveDate" v-if="!fields.effectiveDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.effectiveDate')" :width="8" v-model="giGeneralInfo.effectiveDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.effectiveDate.disabled || permissionLevel>3.5"></FITDatePicker>
              <FITDatePicker field="expiryDate" v-if="!fields.expiryDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.expiryDate')" :width="8" v-model="giGeneralInfo.expiryDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.expiryDate.disabled || permissionLevel>3.5"></FITDatePicker>
            </b-col>
            <b-col cols="6">
              <FITDatePicker field="issueDate" v-if="!fields.issueDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.issueDate')" :width="8" v-model="giGeneralInfo.issueDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.issueDate.disabled || permissionLevel>3.5"></FITDatePicker>
            </b-col>
          </b-row>
        </template>
        <template v-if="!fields.companyReceiveDate.hide">
          <b-row>
            <b-col cols="6">
              <FITDatePicker field="companyReceiveDate" v-if="!fields.companyReceiveDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.companyReceiveDate')" :width="8" v-model="giGeneralInfo.companyReceiveDate" :placeholder="$t('general.selectDate')" :disabled="isInforcedFieldsDisabled && fields.companyReceiveDate.disabled || permissionLevel>3.5"></FITDatePicker>
              <FITDatePicker field="customerReceiveDate" v-if="!fields.customerReceiveDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.customerReceiveDate')" :width="8" v-model="giGeneralInfo.customerReceiveDate" :placeholder="$t('general.selectDate')" :disabled="isInforcedFieldsDisabled && isPolicyCompleted || permissionLevel>3.5"></FITDatePicker>
            </b-col>
            <b-col>
              <FITDatePicker field="agentReceiveDate" v-if="!fields.agentReceiveDate.hide" :label="$t('osm.contents.giPolicy.generalInformation.agentReceiveDate')" :width="8" v-model="giGeneralInfo.agentReceiveDate" :placeholder="$t('general.selectDate')" :disabled=" isInforcedFieldsDisabled && fields.agentReceiveDate.disabled || permissionLevel>3.5"></FITDatePicker>
            </b-col>
          </b-row>
        </template>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITvSelect, FITTextInput, FITDatePicker, FITSelect, FITTextarea, FITAutoSearch, FITWorkflowFileUpload } from '@/components'
import { PolicyAgent } from '@/Osm/components'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'
export default {
  name: 'NewGIPolicyGeneralInfo',
  components: {
    FITFormCard,
    FITvSelect,
    FITTextInput,
    FITDatePicker,
    FITSelect,
    FITTextarea,
    FITAutoSearch,
    FITWorkflowFileUpload,
    PolicyAgent
  },
  created() {
    this.getSelectionsList();
    if (this.workflowCurrentIndex == 0) {
      this.$store.dispatch('GIPolicy/setGIGeneralInfoInitState');
      Vue.set(this, 'isLocked', false);
    }
  },
  computed: {
      permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    approveAgentName() {
      if (this.approveAgent.englishFullname.length == 0 && this.approveAgent.chineseFullname.length == 0) {
        return 'N/A'
      }
      return this.approveAgent.englishFullname + ' ' + this.approveAgent.chineseFullname
    },
    showLockIcon() {
      if (this.workflowCurrentIndex == 0) {
        return false;
      }
      return true;
    },
    actuallyPaidOrPaymentAmount() {
      return this.actuallyPaid;
    },
    sentOutMediumOptions() {
      return this.getOptions("sentOutMedium");
    },
    newBusinessOrRenewalOptions() {
      return this.getOptions("newBusinessOrRenewal");
    },
    policyTypeList() {
      return this.getOptions("policyType");
    },
    companyBankList() {
      return this.getOptions("companyBank")
    },
    paymentMethodList() {
      return this.getOptions("paymentMethod")
    },
    policyCurrency() {
      return this.getOptions("policyCurrency");
    },
    agentNet() {
      return ((parseFloat(this.giGeneralInfo.modalPremium) * (100 - parseFloat(this.giGeneralInfo.agentCommissionRate)) / 100) + parseFloat(this.giGeneralInfo.levyOrMib) + parseFloat(this.giGeneralInfo.policyFee)).toFixed(2);
    },
    agentCommission() {
      var ans = (parseFloat(this.actuallyPaidOrPaymentAmount) - parseFloat(this.agentNet))

      if (ans <= 0 || isNaN(ans) || this.agentNet <= 0) {
        return 0
      }
      return ans.toFixed(2);

    },
    ...mapState({
      fields: state => state.GIPolicy.newGI.fields,
      // policyTypeList: state => state.GIPolicy.newGI.policyTypeList,
      workflowCurrentIndex: state => state.GIPolicy.newGI.workflowCurrentStep,
      trueFalseOptions: state => state.GIPolicy.trueFalseOptions,
      vuexGiGeneralInfo: state => state.GIPolicy.newGI.giGeneralInfo,
      vuexGIPaymentMethod: state => state.GIPolicy.newGI.giPaymentMethod,
      vuexGIAttachments: state => state.GIPolicy.newGI.giAttachments,
      isPolicyRejected: state => state.GIPolicy.newGI.isRejected,
      isPolicyCompleted: state => state.GIPolicy.newGI.isCompleted

    }),
    ...mapGetters("GIPolicy", [
      // 'getTranslatedPolicyTypeList',
      'getTranslatedOptions'
    ]),

  },
  methods: {
    getOptions(columnName) {
      var obj = this.allSelections.filter((item) => { return item.name === columnName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      return obj[0].options;

    },
    changeLockStatus() {
      Vue.set(this, 'isLocked', !this.isLocked);
      if (this.workflowCurrentIndex > 5) {
        Vue.set(this, 'isInforcedFieldsDisabled', !this.isInforcedFieldsDisabled);
        return;
      }
      Vue.set(this, 'isAllFieldsDisabled', !this.isAllFieldsDisabled);
    },
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this, 'newFileUploaded', fileData);
      return fileData;
    },
    getProductList() {
      this.$store.dispatch('autoComplete', "gi")
    },

    getSelectionsList() {
      this.$store.dispatch('getAllSelections', "gi")
        .then((response) => {
          if (response.status != 200) {
            return;
          }
          Vue.set(this, 'allSelections', response.data);
        }, (err) => {
          console.error(err);
        })
    },
    getProductFields() {
      this.$store.dispatch('GIPolicy/getGIProductFields', this.giGeneralInfo.policyType);
    },
    onInputChange() {
      this.$emit('input', this.giGeneralInfo, this.giPaymentMethod);
    },
    resetFileUpload() {
      var newData = this.newFileUploaded;
      if (!newData.files) {
        return;
      }
      this.$refs.fitFileUpload.removeAllFile();
      for (var i = 0; i < newData.files.length; i++) {
        var fileName = newData.files[i].name;
        var size = newData.files[i].size;
        var publicDocument = newData.attachment.publicDocument[i];
        var remarks = newData.attachment.remarks[i];
        var documentTag = newData.attachment.documentTag[i];
        this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag })
      }
      Vue.set(this, 'newFileUploaded', {});
      this.$refs.fitFileUpload.unlockFiles();
    },
    saveToVuex() {
      this.$store.commit({ type: 'GIPolicy/setGIGeneralInfo', giGeneralInfo: this.giGeneralInfo, giPaymentMethod: this.giPaymentMethod });
    },
    searchOption(obj, success) {
      var payload = {
        ...obj,
        ...{ dest: "option" },
      }
      this.$store.dispatch('searchOption', payload)
        .then((json) => {
          success(json);
        })
        .catch((err) => {
          console.debug(err);
        });
    },
    searchAgentOrCustomer(optionType, id, dataKey) {
      var payload = { optionType: optionType, searchInput: { ID: id } }
      this.searchOption(payload, (json) => {
        this.$store.commit({ type: 'GIPolicy/setName', key: dataKey, chinese: json[0].chineseFullname, english: json[0].englishFullname });
        Vue.set(this, dataKey, {
          ID: json[0].ID,
          englishFullname: json[0].englishFullname,
          chineseFullname: json[0].chineseFullname
        });
      });
    }

  },
  watch: {
    // 'vuexGiGeneralInfo.policyAgent': function(newData, oldData) {
    //   console.debug(newData);
    // },
    vuexGIAttachments(newData, oldData) {
      for (var i = 0; i < newData.length; i++) {
        var fileName = newData[i].documentName;
        var size = newData[i].fileSize;
        var publicDocument = newData[i].publicDocument;
        var remarks = newData[i].remarks;
        var documentTag = newData[i].documentTag;
        var ID = newData[i].ID;
        this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag, ID })
      }
    },
    'vuexGiGeneralInfo.productID': function(newData, oldData) {
      if (newData == -1) {
        return;
      }
      var payload = { optionType: "gi", searchInput: { ID: newData } }
      this.searchOption(payload, (json) => {
        this.$store.commit({ type: 'GIPolicy/setName', key: 'productName', chinese: json[0].productChineseName, english: json[0].productEnglishName });
        Vue.set(this, 'selectedProduct', {
          ID: json[0].ID,
          productEnglishName: json[0].productEnglishName,
          productChineseName: json[0].productChineseName
        });
      });
    },
    'vuexGiGeneralInfo.approveAgent': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("agent", newData, "approveAgent");
    },
    'vuexGiGeneralInfo.currentAgent': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("agent", newData, "currentAgent")
    },


    // 'vuexGiGeneralInfo.originalAgent': function(newData, oldData) {
    //   if (newData == -1 || newData == null) {
    //     return;
    //   }
    //   this.searchAgentOrCustomer("agent", newData, "originalAgent")
    // },
    'vuexGiGeneralInfo.ownerCustomer': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("customer", newData, "ownerCustomer")
    },
    'vuexGiGeneralInfo.insuredCustomer': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("customer", newData, "insuredCustomer")
    },

    'vuexGiGeneralInfo.policyAgent': function(newData, oldData) {
      if (newData == null) {
        return;
      }
      Vue.set(this.giGeneralInfo, 'policyAgent', newData);
    },

    selectedProduct(newData, oldData) {
      Vue.set(this.giGeneralInfo, 'productID', newData.ID);
    },
    actuallyPaidOrPaymentAmount(newData, oldData) {
      Vue.set(this.giGeneralInfo, 'customerActuallyPaid', newData);
      Vue.set(this.giPaymentMethod, 'paymentAmount', newData);
    },
    vuexGiGeneralInfo(newData, oldData) {
      var obj = JSON.parse(JSON.stringify(newData));
      Vue.set(this, 'giGeneralInfo', obj);
      // console.debug(obj);
      console.log("GeneralInfo Changed");
    },
    vuexGIPaymentMethod(newData, oldData) {
      var obj = JSON.parse(JSON.stringify(newData));
      Vue.set(this, 'giPaymentMethod', obj);
    },
    'vuexGIPaymentMethod.linkedEntityID': function(newData, oldData) {
      if (newData == null) {
        return;
      }
      Vue.set(this.giPaymentMethod, 'linkedEntityID', newData);
    },
    workflowCurrentIndex(newData, oldData) {
      Vue.set(this, 'isInforcedFieldsDisabled', true);
      Vue.set(this, 'isAllFieldsDisabled', true);
      Vue.set(this, 'isLocked', true);
    },

    actuallyPaid(newData, oldData) {
      Vue.set(this.giGeneralInfo, 'customerActuallyPaid', newData);
      Vue.set(this.giPaymentMethod, 'paymentAmount', newData);
    },

    giGeneralInfo: {
      handler(newData, oldData) {
        this.onInputChange();
      },
      deep: true
    },

    'giGeneralInfo.policyType': function(newData, oldData) {
      if (newData == null || newData.length == 0) {
        return;
      }
      this.getProductFields();
    },

    // originalAgent(newData, oldData) {
    //   Vue.set(this.giGeneralInfo, 'originalAgent', this.originalAgent.ID)
    // },
    // currentAgent(newData, oldData) {
    //   Vue.set(this.giGeneralInfo, 'currentAgent', this.currentAgent.ID)
    // },
    ownerCustomer(newData, oldData) {
      Vue.set(this.giGeneralInfo, 'ownerCustomer', this.ownerCustomer.ID)
    },
    insuredCustomer(newData, oldData) {
      Vue.set(this.giGeneralInfo, 'insuredCustomer', this.insuredCustomer.ID)
    }
  },
  mounted() {
    // if (this.giGeneralInfo.policyType) {

    //   this.getProductFields();
    // }
  },
  data() {
    return {
      isLocked: true,
      selectedProduct: { ID: -1 },
      isInforcedFieldsDisabled: true,
      isAllFieldsDisabled: true,
      isUploadedNewFile: false,
      newFileUploaded: {},
      translatedCompanyBankOptions: [],
      translatedPolicyTypeOptions: [],
      translatedPaymentMethodOptions: [],
      allSelections: [],
      actuallyPaid: 0,
      // originalAgent: { ID: -1 },
      approveAgent: { chineseFullname: '', englishFullname: '' },
      // currentAgent: { ID: -1 },
      insuredCustomer: { ID: -1 },
      ownerCustomer: { ID: -1 },

      giPaymentMethod: {},
      giGeneralInfo: {},
      productAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'gi',
        paras: [{ key: 'type', value: "gi" }],
        showItems: ['productEnglishName', 'productChineseName']
      },
      agentAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'agent' }],
        showItems: ['englishFullname', 'chineseFullname', 'agentCode'],
      },
      customerAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'customer' }],
        showItems: ['englishFullname', 'chineseFullname'],
      },
      uploadedFiles: []
    }
  },
  destroyed() {
    // Object.assign(this.$data, this.$options.data.apply(this))
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/components/NewGIPolicy/NewGIPolicyGeneralInfo.vue